import { render, staticRenderFns } from "./CautionMessage.vue?vue&type=template&id=2f50ff62&"
import script from "./CautionMessage.vue?vue&type=script&lang=js&"
export * from "./CautionMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports